(() => {
  if (customElements.get('phone-field')) {
    return;
  }

  class PhoneField extends HTMLElement {
    constructor() {
      super();

      this.onUpdate = this.onUpdate.bind(this);
      this.onCountryChange = this.onCountryChange.bind(this);
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    attachEvents() {
      this.input.addEventListener('change', () =>
        this.onUpdate({ showError: true }),
      );

      this.debouncedOnUpdate = debounce(() => {
        this.onUpdate({ showError: false });
      }, 300);

      this.input.addEventListener('input', this.debouncedOnUpdate.bind(this));

      this.input.addEventListener('countrychange', this.onCountryChange);
    }

    init() {
      this.input = this.querySelector('input');
      this.country = window.shopSelectedCountry.iso_code;
      this.instance;

      if (!this.input) {
        return;
      }

      this.instance = window.intlTelInput(this.input, {
        nationalMode: false,
        formatAsYouType: false,
        formatOnDisplay: false,
        initialCountry: this.country,
        loadUtils: () => import('./utils.js'),
      });
    }

    onUpdate({ showError = true } = {}) {
      const phoneNumber = this.input.value;
      const field = this.input.closest('.field');

      field?.classList.remove('field--has-error');

      const markError = () => {
        if (showError) {
          field?.classList.add('field--has-error');
        }
      };

      if (!phoneNumber || phoneNumber.trim() === '' || phoneNumber.length < 2) {
        markError();

        return;
      }

      const phoneData = this.parse(phoneNumber);

      if (phoneData && phoneData.isValid()) {
        this.input.value = phoneData.format('E.164');
        this.instance.setCountry(phoneData.country);
      } else {
        markError();
      }
    }

    parse(phoneNumber) {
      try {
        return libphonenumber.parsePhoneNumber(phoneNumber, this.country);
      } catch (error) {
        return null;
      }
    }

    isValidNumber() {
      const phoneNumber = this.input?.value?.trim();

      if (!phoneNumber) {
        return false;
      }

      return Boolean(this.parse(phoneNumber)?.isValid());
    }

    onCountryChange() {
      this.country = this.instance
        .getSelectedCountryData()
        ?.iso2?.toUpperCase();

      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  customElements.define('phone-field', PhoneField);
})();
